import { Pipe, PipeTransform } from '@angular/core';
import { OrganizationProfile } from '../../models/entities/organization-profile';
import { ConfigGeoRegions } from '../../config/geo-regions';
import { Address } from '../../models/entities/address';
import { MembershipProfile } from '../../models/entities/membership-profile';

@Pipe({
    standalone: true,
    name: 'addressLine',
})
export class AddressLinePipe implements PipeTransform
{
    transform(value: OrganizationProfile|MembershipProfile|Address, oneLine = true, abbreviatedState = true): string {
        if (!value) {
            return 'Missing address';
        }

        const address = value instanceof Address ? value : new Address({
            line1: value.address1,
            line2: value.address2,
            city: value.city,
            region: value.state,
            postalCode: value.zip,
        });

        const line = this.formatAddress(address, oneLine ? 'dot' : 'newline', abbreviatedState);
        return `<address>${line}</address>`;
    }

    private formatAddress(address: Address, separator: 'newline'|'dot'|null = 'dot', abbreviatedState = true): string {
        let line = '';
        if (address.line1) {
            line += address.line1 + ' ';
        }
        if (address.line2) {
            line += address.line2 + ' ';
        }

        let geographicLocation = '';
        if (address.city) {
            geographicLocation += address.city;
        }

        if (address.region) {
            let state = address.region;
            if (abbreviatedState) {
                const region = ConfigGeoRegions.RegionsByCountry[0].regions.find(
                        (s) => s.region === state
                );
                state = region.abbreviation;
            }

            geographicLocation += (address.city ? ', ' : '') + state;
        }

        if (address.postalCode) {
            geographicLocation += ' ' + address.postalCode;
        }

        if (line !== '' && geographicLocation !== '') {
            if (separator === 'newline') {
                line += '<br>';
            }
            if (separator === 'dot') {
                line += ' • ';
            }
        }

        return line + geographicLocation;
    }
}
